/**
 * Unified Template Converter
 * Converts policy pack templates to ReportTemplate format
 */

import { PolicyPackReportTemplate } from './policyPackLoader';
import { ReportTemplate } from '../types/reports';
import { getTemplateIconColor } from './templateMapper';

/**
 * Convert policy pack templates to ReportTemplate format
 */
export function convertPolicyPackTemplatesToReportTemplates(
  policyPackTemplates: PolicyPackReportTemplate[]
): ReportTemplate[] {
  return policyPackTemplates.map((ppt) => {
    // Extract category from the template (if available in metadata)
    const category = (ppt as any).category || '';
    
    const { icon, color } = getTemplateIconColor(ppt.id, category, ppt.name);
    
    // Ensure questions array exists
    const questions = ppt.questions || [];
    
    // Build regulatory context from available fields
    const regulatoryContext = {
      authorities: ppt.authorities || [],
      deadline: ppt.deadline || 'As required',
      frequency: ppt.frequency || 'As needed',
      submissionTo: ppt.submissionTo || ppt.authorities || [],
    };
    
    return {
      id: ppt.id,
      type: ppt.id, // Use id as type
      name: ppt.name,
      description: ppt.description || `Report template for ${ppt.name}`,
      icon,
      color,
      questions,
      regulatoryContext,
    };
  });
}











